function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 2230 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1818.7 1316.8c-1.1-204.2 91.2-358.3 278.1-471.7-104.6-149.6-262.6-232-471.2-248.1-197.5-15.6-413.3 115.2-492.3 115.2-83.4 0-274.8-109.6-425-109.6C397.9 607.5 68 850 68 1343.5c0 145.7 26.7 296.3 80.1 451.7 71.2 204.2 328.2 704.8 596.4 696.5 140.2-3.3 239.2-99.6 421.7-99.6 176.9 0 268.7 99.6 425 99.6 270.4-3.9 502.9-458.9 570.8-663.7-362.8-170.8-343.3-500.7-343.3-511.2m-314.8-913.5C1655.7 223.1 1641.8 59 1637.4 0c-134.1 7.8-289.3 91.2-377.7 194.1-97.4 110.1-154.7 246.4-142.4 400 145.1 11.2 277.5-63.4 386.6-190.8",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.26abf9ae62e8fe2542a8e108b03cf92b.svg";
export { ForwardRef as ReactComponent };